import { userConstants } from "../../constant";

export function getAllsponsorshipProductReducer(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_ALL_SPONSORSHIP_PRODUCT_SUCCESS:
      return {
        products: action.products,
      };

    case userConstants.GET_A_SPONSORSHIP_PRODUCT_FAILURE:
      return {
        error: action.error,
      };

    case userConstants.GET_ALL_SPONSORSHIP_PRODUCTS_FAILURE:
      return {
        error: action.error,
      };
    default:
      return state;
  }
}
